var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 259.463,
    height: 155,
    viewBox: "0 0 259.463 155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-3{fill:#fff}.cls-4{fill:#a2c6ff}.cls-11{fill:none}.cls-6{fill:#878787}.cls-10{stroke:none}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5079",
    "data-name": "Group 5079",
    transform: "translate(-31 -97)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_428",
    "data-name": "Group 428",
    transform: "translate(103.303 97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1720",
    fill: "#2a7cff",
    d: "M-282.183-1027.369l.055 88.965q.006 12.2-.011 24.4c-.009 5.486-3.211 8.726-8.658 8.727q-84.518.017-169.036.016c-6.5 0-9.451-2.972-9.451-9.5q0-56.3.032-112.606c1.408-1.109 3.077-.769 4.652-.771q39.491-.032 78.98-.015 49.395 0 98.789.016c1.572.001 3.244-.355 4.648.768z",
    "data-name": "Path 1720",
    transform: "translate(469.285 1059.875)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1721",
    fill: "#2d2f39",
    d: "M-282.17-1057.847l-86.164.059q-49.056.013-98.112-.008c-.931 0-1.862-.031-2.794-.048-.006-7.876-.027-15.753-.015-23.629.009-5.567 3.282-8.858 8.832-8.86q58.184-.02 116.368-.019 26.424 0 52.848.017c5.908.006 9.113 3.247 9.095 9.115q-.036 11.686-.058 23.373z",
    "data-name": "Path 1721",
    transform: "translate(469.272 1090.353)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1723",
    d: "M-433.424-1058.264c-4.573-.1-3.926.753-3.913-4.652.01-4.133-.769-3.468 5.076-3.468 3.65 0 2.995-.688 3.033 5.267.023 3.383.256 2.806-4.196 2.853z",
    className: "cls-3",
    "data-name": "Path 1723",
    transform: "translate(453.64 1078.62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1724",
    d: "M-397.271-1062.277c0 4.014 0 4.014-4.567 4.013-3.57 0-3.6 0-3.558-4.757.039-4.06-.614-3.332 4.938-3.367 3.766-.023 3.125-.351 3.187 4.111z",
    className: "cls-3",
    "data-name": "Path 1724",
    transform: "translate(437.965 1078.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1725",
    d: "M-369.272-1066.4c3.922.007 3.962.008 3.9 4.673-.055 4.11.752 3.446-5.106 3.447-3.626 0-2.975.682-3.011-5.289-.021-3.347-.275-2.783 4.217-2.831z",
    className: "cls-3",
    "data-name": "Path 1725",
    transform: "translate(422.329 1078.613)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_429",
    "data-name": "Group 429",
    transform: "translate(148.307 142.454)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1706",
    d: "M255.6-309.384c-.025-8.372 0-16.745-.11-25.116-.024-1.937.7-2.445 2.529-2.441q25.657.062 51.315-.027c1.848-.006 2.587.582 2.515 2.484-.127 3.326-.072 6.659-.093 9.989-1.123 3.643-1.591 7.492-3.392 10.92-1.733 3.3-3.768 6.205-8.1 6.061-2.863-.1-4.57-1.484-5.371-4.71-.506-2.043-1.383-3.688-3.39-4.568a4.366 4.366 0 0 0-5.58 1.231c-1.708 1.855-2.825 4.166-4.686 5.918-4.09 3.851-9.855 2.928-12.4-2.018-.788-1.531-1.261-3.176-1.894-4.762-1.088-2.724-2.573-2.974-4.568-.777-1.714 1.887-2.591 4.317-4.063 6.36-.652.91-1.153 2.191-2.712 1.456z",
    className: "cls-3",
    "data-name": "Path 1706",
    transform: "translate(-186.169 336.968)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1707",
    d: "M127.907-214.082c-.008-8.2.031-16.408-.058-24.611-.021-1.887.6-2.474 2.476-2.468q25.692.086 51.385 0c1.853-.006 2.576.541 2.509 2.447-.122 3.512-.058 7.031-.072 10.546a2.866 2.866 0 0 1-2.86 1c-6.35-.576-9.753 1.4-12.39 7.187-1.231 2.7-2.257 5.5-4.442 7.641a4.642 4.642 0 0 1-7.1-.058 9.163 9.163 0 0 1-1.025-1.252c-3.785-5.469-10.468-5.388-14.129.036a8.276 8.276 0 0 1-5.684 3.746c-3.964.668-6.966-.765-8.61-4.214z",
    className: "cls-3",
    "data-name": "Path 1707",
    transform: "translate(-127.809 293.164)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1708",
    d: "M255.561-215.188c-.021-7.938-.011-15.876-.086-23.814-.016-1.641.576-2.2 2.2-2.194q25.98.068 51.96.021c1.6 0 2.317.444 2.208 2.141-.126 1.977-.068 3.967-.091 5.951a13.127 13.127 0 0 0-3.846 8.1 30.269 30.269 0 0 1-2.093 8.352c-1.447 3.352-4.124 4.213-7.223 2.316a53.577 53.577 0 0 1-4.332-3.211c-2.667-2.027-4.4-2.04-7.082-.135-2.711 1.926-4.371 1.766-6.5-.739a17.386 17.386 0 0 0-2.766-2.936c-2.673-1.966-5.254-1.2-6.415 1.9-.538 1.435-.818 2.946-1.228 4.418-1.052 3.776-3.434 5.889-6.705 5.971q-5.824.145-7.756-5.652a2.6 2.6 0 0 0-.245-.489z",
    className: "cls-3",
    "data-name": "Path 1708",
    transform: "translate(-186.161 293.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1709",
    d: "M127.926-303.387c-.025-10.268 0-20.537-.117-30.8-.024-2.158.725-2.758 2.8-2.75q25.536.1 51.072.022c1.831 0 2.579.524 2.532 2.451-.125 5.132-.091 10.267-.12 15.4-.683 1.749-2.054 2.294-3.829 2.409a17.536 17.536 0 0 1-8.134-1.509c-.579-.247-1.191-.426-1.748-.708-6.158-3.115-10.336-.978-13.518 4.894-2.459 4.538-5.073 5.354-9.747 3.061l-.24-.122c-5.552-2.836-5.567-2.848-9.657 2.092-1.72 2.078-3.337 4.246-5.717 5.651-1.213.714-2.419 1.347-3.577-.091z",
    className: "cls-3",
    "data-name": "Path 1709",
    transform: "translate(-127.791 336.955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1710",
    d: "M127.911-290.566c3.023-.341 4.939-2.355 6.757-4.5 1.45-1.71 2.758-3.555 4.325-5.149 2.076-2.113 4.144-2.207 6.5-.451a13.253 13.253 0 0 0 3.757 2.063c2.9.957 4.629.315 6.012-2.394a19.019 19.019 0 0 1 3.486-5.075 8.72 8.72 0 0 1 10.136-2.027c1.92.763 3.826 1.568 5.772 2.256a11.729 11.729 0 0 0 9.421-.4c.027 6.043-.028 12.088.12 18.128.059 2.421-.909 3.086-3.192 3.076q-25.166-.109-50.33-.022c-2.322.009-3.089-.923-2.865-3.068.09-.81.071-1.625.101-2.437z",
    className: "cls-4",
    "data-name": "Path 1710",
    transform: "translate(-127.775 324.134)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1711",
    d: "M255.568-208.355c1.374 1.41 2.518 3.05 4.325 4.015 3.908 2.088 7.722.566 8.974-3.667.536-1.81.866-3.686 1.46-5.474 1.272-3.829 5.294-4.9 8.364-2.219a28.143 28.143 0 0 1 3.079 3.391c1.393 1.695 2.793 2.006 4.6.514 3.16-2.607 5.446-2.56 8.642-.064a53.8 53.8 0 0 0 4.309 3.237c2.52 1.589 4.248 1.016 5.307-1.736a49.14 49.14 0 0 0 2.361-10.235c.558-3.6 1.612-4.865 4.773-5.658.019 9.471.01 18.942.081 28.412.015 1.889-.75 2.52-2.576 2.515q-25.573-.055-51.146.008c-2.054.007-2.681-.855-2.63-2.758.093-3.426.059-6.853.077-10.281z",
    className: "cls-4",
    "data-name": "Path 1711",
    transform: "translate(-186.168 286.346)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1712",
    d: "M127.907-203.589a10.615 10.615 0 0 0 5.972 2.855 7.025 7.025 0 0 0 7.061-2.9c1.79-2.345 3.629-4.557 7.045-4.917 4.243-.447 7.021 1.44 9.4 4.575 2.71 3.57 5.1 3.467 7.474-.426 1.305-2.141 2.272-4.49 3.371-6.755a12.072 12.072 0 0 1 13.252-6.868c.884.145 1.777.234 2.666.35.021 7.831.014 15.662.085 23.492.016 1.826-.652 2.58-2.525 2.575q-25.654-.072-51.309-.03c-1.841 0-2.609-.612-2.546-2.5.104-3.149.047-6.301.054-9.451z",
    className: "cls-4",
    "data-name": "Path 1712",
    transform: "translate(-127.809 282.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1713",
    d: "M255.6-298.877c1.5-1.366 2.266-3.221 3.234-4.935a19.3 19.3 0 0 1 3.686-4.97c2.334-2.121 4.15-1.7 5.324 1.285.758 1.927 1.328 3.94 2.218 5.8 1.943 4.064 6.782 4.852 10.133 1.785 1.755-1.607 2.839-3.718 4.285-5.555 1.412-1.792 2.986-3.292 5.418-2.811 2.875.569 5.322 1.909 6.008 5.1.491 2.284.973 4.487 3.808 4.891 3.15.449 5.262-1.258 6.612-3.734a61.679 61.679 0 0 0 2.923-7.257c.649-1.67 1.046-3.471 2.507-4.708.021 7.936-.008 15.873.1 23.808.028 2.169-.857 2.783-2.9 2.779q-25.162-.061-50.324.037c-2.323.01-3.279-.742-3.134-3.13.164-2.788.074-5.59.102-8.385z",
    className: "cls-4",
    "data-name": "Path 1713",
    transform: "translate(-186.163 326.461)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1757",
    d: "M0 0H13V92H0z",
    className: "cls-4",
    "data-name": "Rectangle 1757",
    transform: "translate(118 142)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_406",
    "data-name": "Group 406",
    transform: "translate(30.679 133.327)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1695",
    fill: "none",
    stroke: "#878787",
    strokeDasharray: 2,
    "data-name": "Rectangle 1695",
    transform: "translate(.321 -.327)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 119,
    className: "cls-10",
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 118,
    x: 0.5,
    y: 0.5,
    className: "cls-11",
    rx: 9.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1696",
    d: "M0 0H56V85H0z",
    className: "cls-6",
    "data-name": "Rectangle 1696",
    transform: "translate(3.321 18.673)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1697",
    fill: "#f5f5f5",
    stroke: "#707070",
    strokeWidth: "0.2px",
    "data-name": "Rectangle 1697",
    transform: "translate(22.321 7.673)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 3,
    className: "cls-10",
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.8,
    height: 2.8,
    x: 0.1,
    y: 0.1,
    className: "cls-11",
    rx: 1.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_727",
    fill: "#f5f5f5",
    stroke: "#878787",
    strokeWidth: "0.2px",
    "data-name": "Ellipse 727",
    transform: "translate(26.321 105.673)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    className: "cls-10"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.9,
    className: "cls-11"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1698",
    width: 51,
    height: 8,
    fill: "#f5f5f5",
    "data-name": "Rectangle 1698",
    rx: 2,
    transform: "translate(6.321 21.673)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1700",
    width: 51,
    height: 33,
    className: "cls-3",
    "data-name": "Rectangle 1700",
    rx: 1,
    transform: "translate(6.321 31.673)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_403",
    "data-name": "Group 403",
    transform: "translate(7.45 45.909)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    d: "M199 186.032l4.493-6.5a2.878 2.878 0 0 1 4.041-.7l.631.451a2.877 2.877 0 0 0 4.4-1.41l2.181-6.382a2.878 2.878 0 0 1 5.446 0l1.055 3.088a2.877 2.877 0 0 0 5.353.235l.916-2.066a2.877 2.877 0 0 1 5.006-.458 2.877 2.877 0 0 0 5.1-.693l1.021-2.986a2.877 2.877 0 0 1 5.528.291l3.9 17.132s-48.933-.134-49.071-.002z",
    className: "cls-6",
    "data-name": "Path 194",
    transform: "translate(-199.001 -166.662)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1758",
    width: 51,
    height: 33,
    className: "cls-3",
    "data-name": "Rectangle 1758",
    rx: 1,
    transform: "translate(6.321 67.673)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_430",
    "data-name": "Group 430",
    transform: "translate(7.45 81.909)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_194-2",
    d: "M248.07 186.032l-4.493-6.5a2.878 2.878 0 0 0-4.041-.7l-.631.451a2.877 2.877 0 0 1-4.4-1.41l-2.181-6.382a2.878 2.878 0 0 0-5.446 0l-1.055 3.088a2.877 2.877 0 0 1-5.353.235l-.916-2.066a2.877 2.877 0 0 0-5.006-.458 2.877 2.877 0 0 1-5.1-.693l-1.021-2.986a2.877 2.877 0 0 0-5.528.291L199 186.032s48.933-.132 49.07 0z",
    className: "cls-6",
    "data-name": "Path 194",
    transform: "translate(-199.001 -166.662)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileView);
export default __webpack_public_path__ + "static/media/mobile_view.8242005caaec4249fbe77bfbc48b5574.svg";
export { ForwardRef as ReactComponent };